// extracted by mini-css-extract-plugin
module.exports = {"imageSample":"style_imageSample__2JF9Q"};